import "reflect-metadata"
import AmplilyWidget from "./single-widget.vue"
import { AwOptions } from "../models/AwOptions"
import { exposeAmplilyWidget } from "@/services/setupAmplilyWidget"
import { createWebinarVueApp } from "./create-webinar-vueapp"
;(window as any).setupAmplilySingle = (options: AwOptions, el: HTMLElement) => {
  createWebinarVueApp(AmplilyWidget, options, el)
}
exposeAmplilyWidget()
